<umkt-card-wrapper
  [title]="'pages.checkout.steps.schedule' | i18n"
  [icon]="{ name: 'calendario', type: 'mondrian-icons' }"
  [showCheck]="isEditing ? canSubmit() : !!getDisplaySelections()"
  [loading]="showSlotsLoading()"
  [loadingText]="'components.schedulePicker.loading'"
  [initiallyOpen]="true">
  @if (isEditing) {
  <div class="schedule-picker">
  <header class="schedule-picker__header">
    <div class="schedule-picker__header-text">
      <p class="schedule-picker__subtitle">
        {{ 'components.schedulePicker.subtitle' | i18n }}
      </p>
    </div>
  </header>

  @for (opt of options(); track opt.index) {
    <div class="schedule-picker__option" (click)="$event.stopPropagation()">
      <h3 class="schedule-picker__option-label">
        @if (opt.labelKey) {
          {{ opt.labelKey | i18n }}
        } @else {
          {{ opt.label }}
        }
      </h3>
      <div class="schedule-picker__dates-row">
        <button
          type="button"
          class="schedule-picker__nav schedule-picker__nav--left"
          [class.schedule-picker__nav--disabled]="!canGoPrev(opt.index)"
          [disabled]="!canGoPrev(opt.index)"
          (click)="$event.stopPropagation(); prevDates(opt.index)"
          [attr.aria-label]="'components.schedulePicker.ariaPrevDates' | i18n:{ label: getOptionLabel(opt) }"
        >
          <span class="schedule-picker__nav-icon">&lt;</span>
        </button>
        <div class="schedule-picker__dates" [attr.data-cols]="visibleDatesCount()">
          @for (group of getVisibleDates(opt.index); track group.dateKey) {
            <button
              type="button"
              class="schedule-picker__date"
              [class.schedule-picker__date--selected]="getSelectedDateKey(opt.index) === group.dateKey"
              (click)="$event.stopPropagation(); selectDate(opt.index, group)"
            >
              <span class="schedule-picker__date-weekday">{{ getDayOfWeekShort(group.dayOfWeekIndex) }}</span>
              <span class="schedule-picker__date-label">{{ group.label }}</span>
            </button>
          }
        </div>
        <button
          type="button"
          class="schedule-picker__nav schedule-picker__nav--right"
          [class.schedule-picker__nav--disabled]="!canGoNext(opt.index)"
          [disabled]="!canGoNext(opt.index)"
          (click)="$event.stopPropagation(); nextDates(opt.index)"
          [attr.aria-label]="'components.schedulePicker.ariaNextDates' | i18n:{ label: getOptionLabel(opt) }"
        >
          <span class="schedule-picker__nav-icon">&gt;</span>
        </button>
      </div>
      <div class="schedule-picker__period">
        <label [for]="'period' + opt.index" class="schedule-picker__period-label">{{ 'components.schedulePicker.periodLabel' | i18n }}</label>
        <select
          [id]="'period' + opt.index"
          class="schedule-picker__period-select"
          [value]="getSelectedSlotValue(opt.index)"
          [disabled]="!getSelectedDateKey(opt.index)"
          (change)="onPeriodChange(opt.index, $event)"
        >
          <option value="" [selected]="!getSelectedSlotValue(opt.index)">
            {{ 'components.schedulePicker.periodPlaceholder' | i18n }}
          </option>
          @for (slot of getSlotsForDate(opt.index); track slotValue(slot)) {
            <option
              [value]="slotValue(slot)"
              [selected]="slotValue(slot) === getSelectedSlotValue(opt.index)"
            >
              {{ slotOptionLabel(slot) }}
            </option>
          }
        </select>
      </div>
    </div>
  }

  @if (insufficientSlots()) {
    <p class="schedule-picker__warning" role="status">
      {{ 'components.schedulePicker.warning' | i18n }}
    </p>
  }

  <div class="schedule-picker__actions">
    <button type="button" class="btn-outline schedule-picker__back-btn" (click)="previousStep.emit()">
      {{ useCancelInsteadOfBack ? ('shared.buttons.cancel' | i18n) : ('shared.buttons.back' | i18n) }}
    </button>
    <button
      type="button"
      class="btn-primary"
      [disabled]="!canSubmit() || isCardLoading || (!useCancelInsteadOfBack && !canGoToNextStep)"
      (click)="onContinue()"
    >
      {{ (useCancelInsteadOfBack ? 'shared.buttons.save' : 'shared.buttons.continue') | i18n }}
    </button>
  </div>
  </div>
  } @else {
  <div class="schedule-picker schedule-picker--view">
    @if (getDisplaySelections(); as displaySelections) {
      <div class="schedule-picker__options">
        <div class="schedule-picker__view-row schedule-picker__view-row--first">
          <div class="schedule-picker__view-option schedule-picker__view-option--inline">
            <h3 class="schedule-picker__view-option-label">{{ 'components.schedulePicker.firstOption' | i18n }}</h3>
            <p class="schedule-picker__view-option-value">
              {{ getDateLabel(displaySelections.firstOption) }} — {{ slotOptionLabel(displaySelections.firstOption) }}
            </p>
          </div>
          <div class="schedule-picker__view-actions">
            <button type="button" class="pi-edit-btn" (click)="startEditing()">{{ 'components.schedulePicker.editButton' | i18n }}</button>
          </div>
        </div>
        <div class="schedule-picker__view-option">
          <h3 class="schedule-picker__view-option-label">{{ 'components.schedulePicker.secondOption' | i18n }}</h3>
          <p class="schedule-picker__view-option-value">
            {{ getDateLabel(displaySelections.secondOption) }} — {{ slotOptionLabel(displaySelections.secondOption) }}
          </p>
        </div>
      </div>
    }
  </div>
  }
</umkt-card-wrapper>
